import { Grid, Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import {
  PictogramJobPost,
  PictogramEarningMoney,
  PictogramSuccessfulCareer,
} from '@care/react-embrace-icons';
import { useResponsive } from '@/components/hooks/useResponsive';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

export const ValuePropSection = () => {
  const { isSmallViewport } = useResponsive();
  const { segmentNameSingularLowerCase, pageType, city, state } = usePageAttributes();

  const isLocalPage = pageType === 'LOCAL';

  const valueProps = [
    {
      Icon: PictogramJobPost,
      title: 'Job that fits you',
      description: `Find local ${segmentNameSingularLowerCase} opportunities to fit you and your schedule`,
    },
    {
      Icon: PictogramEarningMoney,
      title: 'Take control of your earnings',
      description: `Set your own rate and get your profile in front of families actively looking for ${segmentNameSingularLowerCase} ${isLocalPage ? ` in ${city}, ${state}` : ''}`,
    },
    {
      Icon: PictogramSuccessfulCareer,
      title: 'A trusted community',
      description: `We have spent more than 15 years connecting millions of caregivers to their next opportunity`,
    },
  ];
  return (
    <Box bgcolor="background.primary" py={{ xs: 6, md: 8 }}>
      <Container maxWidth="lg">
        <Grid container columnSpacing={8}>
          <Grid item xs={12}>
            <Typography
              variant={isSmallViewport ? 'h1' : 'display3'}
              component="h2"
              textAlign="center"
              mb={0}
              mt={0}
              mx={isSmallViewport ? 3 : 0}>
              Discover your next {segmentNameSingularLowerCase}
              {isLocalPage ? ` in ${city}, ${state}` : ''}
            </Typography>
          </Grid>
          {valueProps.map(({ Icon, title, description }) => (
            <Grid item xs={12} md={4} key={title} mt={{ xs: 4, md: 6 }}>
              <Box
                alignItems="center"
                justifySelf="center"
                display="flex"
                flexDirection="column"
                maxWidth="500px">
                <Icon size={128} />
                <Typography textAlign="center" variant="h3" mt={2}>
                  {title}
                </Typography>
                <Typography textAlign="center" variant="body2" color="text.secondary" mt={0.5}>
                  {description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
